import React, { Component } from 'react';
import { connect } from 'shalala';
import { Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';

import { Http } from '../../../support';
import { useStore } from '../../../store';
import PagosAddForm from './components/PagosAddForm';
import LoadingButton from '../../../facturotopia/LoadingButton';
import ResponseError from '../../../shared/responses/ResponseError';
import ResponseResult from '../../../shared/responses/ResponseResult';
import PagosTotalesCalculator from '../support/pagos/PagosTotalesCalculator';
import PagosImpuestosCalculator from '../support/pagos/PagosImpuestosCalculator';
import ComprobanteRequestInputTransformer from '../transformers/ComprobanteRequestInputTransformer';

class PagosAdd extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      data: props.data || {},
    };
  }

  handleOnStampingRequest = () => {
    const { data } = this.state;
    const { input } = this.props;

    if (data.MonedaP === 'MXN') {
      data.TipoCambioP = '1';
    }

    if (data.MonedaDR === 'MXN') {
      data.EquivalenciaDR = '1';
    } else if (data.MonedaP === data.MonedaDR) {
      data.EquivalenciaDR = '1';
    }

    const Pagos = [
      {
        FechaPago: data.FechaPago,
        HoraPago: data.HoraPago,
        FormaDePagoP: data.FormaDePagoP,
        MonedaP: data.MonedaP,
        TipoCambioP: data.TipoCambioP,
        Monto: data.Monto,
        DoctoRelacionado: [
          {
            IdDocumento: data.IdDocumento,
            Serie: input.Serie,
            Folio: input.Folio,
            MonedaDR: data.MonedaDR,
            EquivalenciaDR: data.EquivalenciaDR,
            NumParcialidad: data.NumParcialidad,
            ImpSaldoAnt: data.ImpSaldoAnt,
            ImpPagado: data.ImpPagado,
            ImpSaldoInsoluto: data.ImpSaldoInsoluto,
            ObjetoImpDR: data.ObjetoImpDR,
            ImpuestosDR: data.ImpuestosDR,
          },
        ],
      },
    ];

    this.handleOnSubmit(Pagos);
  };

  handleOnSubmit = async (Pagos) => {
    const { input } = this.props;

    const tmpPago = new PagosImpuestosCalculator(Pagos).apply().get();

    const totales = new PagosTotalesCalculator(tmpPago).apply();

    let body = new ComprobanteRequestInputTransformer().make({
      ...input,
      TipoDeComprobante: 'Pago',
      Complemento: {
        Pagos: {
          Version: '2.0',
          Pago: tmpPago,
          Totales: totales,
        },
      },
    });

    this.setState({
      busy: true,
    });

    try {
      const response = await Http.post(`api/comprobantes`, body);

      this.setState({
        result: response,
      });
    } catch (error) {
      this.setState({
        error: error.data || error,
      });
    } finally {
      this.setState({
        busy: false,
      });
    }
  };

  handleOnChange = (event) => {
    this.setState({
      ...this.state,
      ...event,
    });
  };

  handleDownload = (uuid) => {
    const params = {
      type: 'zip',
      as: 'link',
    };

    Http.get(`${window.BONJOUR_URL}/api/comprobantes/${uuid}/download`, { params })
      .then(
        (response) => {
          window.location = response.data.link;
        },
        (error) => {
          window.ToastManager.show({
            variant: 'error',
            title: 'Error',
            message: error.message || 'No fue posible descargar tu factura. =(',
          });
        }
      )
      .finally(() => {
        this.handleOnAction('success');
      });
  };

  handleOnAction = (action) => {
    if (action === 'reset') {
      this.setState({
        ...this.state,
        error: undefined,
        result: undefined,
      });

      return;
    }

    if (action === 'success') {
      this.props.listActions.setListData(this.state.result.data);
    }

    this.props.history.push(`/app/comprobantes/${this.props.uuid}/info`);
  };

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  renderResult = () => {
    const { result } = this.state;

    return (
      <div className="result-container">
        <ResponseResult
          title="Factura emitida"
          result={result}
          extra={
            <>
              <Button
                type="button"
                variant="secondary"
                className="mr-3"
                onClick={() => {
                  this.handleDownload(result.data.uuid);
                }}
              >
                Descargar
              </Button>

              <Button
                type="button"
                onClick={this.handleOnAction.bind(this, 'success')}
              >
                Continuar
              </Button>
            </>
          }
        />
      </div>
    );
  };

  render() {
    const { busy, isValid, data, error, result } = this.state;

    return (
      <>
        {!!error && this.renderError()}

        {!!result && this.renderResult()}

        <PagosAddForm
          data={data}
          onChange={this.handleOnChange}
        />

        <LoadingButton
          loading={busy}
          disabled={!isValid || busy}
          onClick={this.handleOnStampingRequest}
        >
          {busy ? 'Procesando...' : 'Crear factura'}
        </LoadingButton>
      </>
    );
  }
}

const mapState = (store) => {
  return { list: store.app.comprobantes.list };
};

const mapActions = (actions) => {
  return { listActions: actions.app.comprobantes.list };
};

export default connect(useStore, mapState, mapActions)(withRouter(PagosAdd));
